<ng-container *ngFor="let element of elements">
    <ng-container [ngSwitch]="element.type">

        <ng-container *ngSwitchCase="'markdown'">
            <div class="markdown-container" [innerHTML]="element.markdown | MarkdownToHtml"></div>
        </ng-container>

        <ng-container *ngSwitchCase="'map'">
            <div class="map-container">
                <al-leaflet-map [markersSeries]="element.markerSeries"
                                [title]="element.title"
                                [legendTitle]="element.legendTitle"
                                [showLegend]="element.showLegend"
                                [showClusterCount]="element.showClusterCount"
                                [showClusterCoverage]="element.showClusterCoverage"></al-leaflet-map>

            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'json-viewer'">
            <div class="json-viewer-container">
                <al-json-viewer [json]="element.data"></al-json-viewer>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'image'">
            <img [src]="element.source" [title]="element.title" />
        </ng-container>

        <ng-container *ngSwitchCase="'error'">
            <div class="error-container">
                <h3>Error: content unavailable</h3>
                <p>{{element.error}}</p>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'table'">
            <div class="table-container">
                <ald-table [columns]="element.columns" [data]="element.data"></ald-table>
            </div>
        </ng-container>

        <div *ngSwitchCase="'timeline'">
            <div class="card card-w-title">
                <div class="card-content">
                    <div class="pad-top">
                        <al-highchart-timeline [config]="element.timelineConfig"></al-highchart-timeline>
                    </div>
                </div>
            </div>
        </div>

        <!--
        <div *ngSwitchCase="'link'"><a [href]="segment.link.href" [target]="segment.link.target" [title]="segment.link.title">{{segment.rawContent}}</a></div>
        <div *ngSwitchCase="'external-html'" [alExternalHtml]="segment.resourceId"></div>
        <div *ngSwitchCase="'external-text'" [alExternalText]="segment.resourceId"></div>
        <div *ngSwitchCase="'visualization'">
            <al-dashboard-layout [config]="segment.visualization"></al-dashboard-layout>
        </div>
        -->
    </ng-container>
</ng-container>
